import { exposeGlobalAPI, getContext, initContext } from './core';
import { initEventPageTracking } from './listeners/event-page';
import { initExternalLinkTracking } from './listeners/external-links';
import { initHubSpotFormTracking } from './listeners/hubspot-forms';
import { initIntercomTracking } from './listeners/intercom';
import { initPandCtaTracking } from './listeners/pand-cta';
import { initScrollTracking } from './listeners/scroll';
import { initVideoTracking } from './listeners/video';

function init(): void {
  // 1. Read PHP context and expose global API
  initContext();
  exposeGlobalAPI();

  const ctx = getContext();
  if (!ctx.enabled) return;

  // 2. Auto-fire page-load events
  if (ctx.page_type === '404') {
    const { track } = window.InteractTracking!;
    track('404_error', {
      broken_url: window.location.href,
      page_referrer: document.referrer || '(direct)',
    });
  }

  if (ctx.page_type === 'search' && Number(ctx.search_results_count) === 0 && ctx.search_term) {
    const { track } = window.InteractTracking!;
    track('search_no_results', {
      search_term: ctx.search_term,
    });
  }

  // 3. Attach all listeners
  initScrollTracking();
  initExternalLinkTracking();
  initHubSpotFormTracking();
  initVideoTracking();
  initIntercomTracking();
  initEventPageTracking();
  initPandCtaTracking();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
